<template>
    <div class="search-result__professional">
        <div class="search-result__professional-left">
            <a :href="professional.url" :title="'View ' + professional.firstName + ' ' + professional.lastName"
                class="search-result__professional-avatar"
                :style="`background-image: url(${professional.profileImageAvatar});`"></a>
            <div class="search-result__professional-socials">
                <a v-if="professional.linkedInUrl" class="page-contact__icon page-contact__icon--linkedin" target=""
                    :href="professional.linkedInUrl">
                    <i class="icon-linkedin"></i>
                </a>
                <a v-if="professional.officeEmail" class="page-contact__icon page-contact__icon--email mailto-link" href="#"
                    :data-email="`mailto:` + professional.officeEmail" v-on:click.prevent="showMailtoDisclaimer($event)">
                    <i style="pointer-events: none;" class="icon-envelope"></i>
                </a>
            </div>
        </div>
        <div class="search-result__professional-details">
            <div class="search-result__professional-heading">
                <a :href="professional.url" class="search-result__professional-name">{{ professional.firstName }} {{
                    professional.lastName }}</a>
                <p class="search-result__professional-title">{{ professional.title }}</p>
            </div>
            <div style="display: flex; gap: 16px; flex: 1; align-items: flex-end;"
                v-if="professional.additionalArea !== null && professional.additionalArea !== ''">
                <div>
                    <p class="search-result__professional-link" v-if="professional.area !== null"><a
                            :title="professional.area" :href="professional.areaUrl">{{ professional.area }}</a></p>
                    <template v-if="professional.additionalArea !== null">
                        <p class="search-result__professional-link" v-if="professional.additionalArea !== null"><a
                                :title="professional.additionalArea" :href="professional.additionalAreaUrl">{{
                                    professional.additionalArea }}</a></p>
                    </template>
                    <template v-if="professional.additionalArea2 !== null">
                        <p class="search-result__professional-link" v-if="professional.additionalArea2 !== null"><a
                                :title="professional.additionalArea2" :href="professional.additionalArea2Url">{{
                                    professional.additionalArea2 }}</a></p>
                    </template>
                </div>
                <div v-if="professional.area != null && professional.area != ''">
                    <p class="search-result__professional-link"
                        v-if="professional.area !== null && professional.area !== ''"><a title="Direct Phone"
                            :href="`tel:` + professional.directPhone">D: {{
                                professional.directPhone }}</a>
                    </p>
                    <template v-if="professional.additionalArea !== null && professional.additionalArea !== ''">
                        <p class="search-result__professional-link" v-if="professional.directPhone2 !== null"><a
                                title="Direct Phone" :href="`tel:` + professional.directPhone2">D: {{
                                    professional.directPhone2 }}</a>
                        </p>
                    </template>
                    <template v-if="professional.additionalArea2 !== null && professional.additionalArea2 !== ''">
                        <p class="search-result__professional-link" v-if="professional.directPhone3 !== null"><a
                                title="Direct Phone" :href="`tel:` + professional.directPhone3">D: {{
                                    professional.directPhone3 }}</a>
                        </p>
                    </template>
                </div>
            </div>
            <div style="display: flex; gap: 16px; flex: 1; align-items: flex-end;" v-else>
                <div>
                    <p class="search-result__professional-link" v-if="professional.area !== null"><a
                            :title="professional.area" :href="professional.areaUrl">{{ professional.area }}</a></p>
                    <p class="search-result__professional-link"
                        v-if="professional.directPhone !== null && professional.directPhone !== ''"><a title="Direct Phone"
                            :href="`tel:` + professional.directPhone">D: {{
                                professional.directPhone }}</a>
                    </p>
                </div>
            </div>
            <div class="search-result__professional-actions">


                <div class="search-result__professional-contact">




                    <p class="search-result__professional-link" v-if="professional.officeEmail !== null"><a
                            class="mailto-link" title="Email" :data-email="`mailto:` + professional.officeEmail"
                            v-on:click.prevent="showMailtoDisclaimer($event)" href="#">{{ professional.officeEmail }}</a>
                    </p>
                </div>
                <div class="search-result__professional-socials">
                    <a v-if="professional.linkedInUrl" class="page-contact__icon page-contact__icon--linkedin" target=""
                        title="LinkedIn" :href="professional.linkedInUrl">
                        <i class="icon-linkedin"></i>
                    </a>
                    <a v-if="professional.officeEmail" class="page-contact__icon page-contact__icon--email"
                        title="Office Email" :data-email="`mailto:` + professional.officeEmail"
                        v-on:click.prevent="showMailtoDisclaimer($event)" href="#">
                        <i style="pointer-events: none;" class="icon-envelope"></i>
                    </a>
                </div>
            </div>
        </div>
        <a :href="professional.url" :title="'View ' + professional.firstName + ' ' + professional.lastName"
            class="search-result__professional-image" :style="`background-image: url(${professional.profileImage})`"></a>
    </div>
</template>

<script>

export default {
    props: ["professional"],
    data() {
        return {

        }
    },
    methods: {
        showMailtoDisclaimer: function (e) {
            window.showMailtoDisclaimer(e);
        }
    }
}
</script>

